import React from 'react';
import { TrustpilotWidget } from '@qover/molecules';

type SummaryTrustpilotProps = {
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  height?: string;
  id?: string;
};

export function SummaryTrustpilot(props: SummaryTrustpilotProps) {
  return (
    <TrustpilotWidget
      {...props}
      utmMedium="Trustbox"
      utmSource="SummaryPage"
    />
  );
}
